import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Plus } from 'lucide-react';
import { formatCurrency } from '../crmUtils';
import { ETAPA_CORES } from './constants';
import { OportunidadeCard } from './OportunidadeCard';

export const ColunaPipeline = ({ etapa, dados, origens, onAddNew, onView, onEdit, onDelete }) => {
  const cores = ETAPA_CORES[etapa.id] || ETAPA_CORES.lead;

  return (
    <div
      className={`flex-shrink-0 min-w-[280px] w-[calc((100%-64px)/5)] ${cores.bg} ${cores.border} border rounded-lg flex flex-col max-h-[calc(100vh-180px)]`}
      data-testid={`coluna-${etapa.id}`}
    >
      <div className={`${cores.header} p-3 rounded-t-lg border-b ${cores.border}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: etapa.cor }} />
            <h3 className={`font-semibold text-sm ${cores.text}`}>{etapa.nome}</h3>
          </div>
          <Badge variant="secondary" className="text-xs">{dados.oportunidades?.length || 0}</Badge>
        </div>
        <div className="mt-1 text-xs text-gray-500">
          {formatCurrency(dados.oportunidades?.reduce((acc, o) => acc + (o.valor_estimado || 0), 0))}
        </div>
      </div>

      <Droppable droppableId={etapa.id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`flex-1 p-2 overflow-y-auto min-h-[100px] ${
              snapshot.isDraggingOver ? 'bg-blue-50/50' : ''
            }`}
          >
            {dados.oportunidades?.map((opp, idx) => (
              <OportunidadeCard
                key={opp.id}
                oportunidade={opp}
                index={idx}
                origens={origens}
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
            {provided.placeholder}

            {(!dados.oportunidades || dados.oportunidades.length === 0) && (
              <div className="text-center py-6 text-gray-400 text-xs">
                Arraste oportunidades aqui
              </div>
            )}
          </div>
        )}
      </Droppable>

      {(etapa.id === 'lead' || etapa.id === 'em_atendimento') && (
        <div className="p-2 border-t">
          <Button
            variant="ghost"
            size="sm"
            className="w-full text-xs"
            onClick={() => onAddNew(etapa.id)}
            data-testid={`btn-add-${etapa.id}`}
          >
            <Plus className="h-3.5 w-3.5 mr-1" />
            Adicionar
          </Button>
        </div>
      )}
    </div>
  );
};
